module.exports = __webpack_public_path__ + "static/favicon-0bf82e94f604f6753bb6387036f268c8.ico";